import { motion } from "framer-motion";
import { Globe2, Pin } from "lucide-react";

/**
 * Iter-27.63 — Histoires d'impact émotionnelles avec photo, outcome chiffré.
 * Vit uniquement dans /espace-partenaires/:id.
 */
export default function ImpactStoriesList({ items }) {
    if (!items || items.length === 0) {
        return (
            <p className="text-white/40 text-sm py-6 text-center">
                Aucune histoire d'impact publiée pour le moment.
            </p>
        );
    }
    return (
        <div className="space-y-5">
            <p className="text-sm text-white/65 font-light leading-relaxed">
                Chaque don que tu obtiens sur le terrain contribue à transformer des vies. Voici
                quelques-unes de ces histoires.
            </p>
            {items.map((s, idx) => (
                <motion.article
                    key={s.story_id}
                    initial={{ opacity: 0, y: 12 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.4, delay: idx * 0.08 }}
                    className="rounded-3xl overflow-hidden bg-white/3 border border-white/10 group hover:border-white/20 transition-all"
                    data-testid={`impact-story-${s.story_id}`}
                >
                    {s.cover_image_url && (
                        <div className="relative aspect-[16/9] overflow-hidden">
                            <img
                                src={s.cover_image_url}
                                alt={s.title}
                                className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                            />
                            <div className="absolute inset-0 bg-gradient-to-t from-shariti-black via-shariti-black/30 to-transparent" />
                            {s.pinned && (
                                <span className="absolute top-3 left-3 inline-flex items-center gap-1 px-2.5 py-1 rounded-full bg-shariti-yellow text-shariti-black text-[10px] font-extrabold uppercase tracking-wider">
                                    <Pin className="w-3 h-3" /> À LA UNE
                                </span>
                            )}
                            {s.outcome && (
                                <div className="absolute bottom-3 right-3 px-3 py-1.5 rounded-2xl bg-shariti-orange text-white text-xs font-extrabold uppercase tracking-wider">
                                    {s.outcome}
                                </div>
                            )}
                        </div>
                    )}
                    <div className="p-5 sm:p-6">
                        <div className="flex items-center gap-3 text-[10px] font-thin tracking-[0.22em] uppercase text-white/45 mb-2">
                            {s.location && (
                                <span className="inline-flex items-center gap-1">
                                    <Globe2 className="w-3 h-3" />
                                    {s.location}
                                </span>
                            )}
                            {s.year && <span>· {s.year}</span>}
                        </div>
                        <h3 className="text-xl sm:text-2xl font-extrabold text-white mb-2 leading-tight">
                            {s.title}
                        </h3>
                        {s.summary && (
                            <p className="text-sm text-shariti-orange-light font-bold mb-3">
                                {s.summary}
                            </p>
                        )}
                        <p className="text-sm text-white/75 font-light leading-relaxed whitespace-pre-line">
                            {s.body}
                        </p>
                    </div>
                </motion.article>
            ))}
        </div>
    );
}
